import { Box, Typography } from "@mui/material";
import ReusableInfoModal from "../../General/ReusableInfoModal/ReusableInfoModal";

const LenderInfoModal = ({
  id,
  open,
  onClose,
}: {
  id: string;
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <ReusableInfoModal
      endpoint="getLender"
      entityId={id}
      open={open}
      onClose={onClose}
      title="Lender Information"
      renderData={(lender) => (
        <Box>
          <Typography>Name: {lender.name}</Typography>
          <Typography>Email: {lender.email}</Typography>
          <Typography>City: {lender.city}</Typography>
          <Typography>Phone number: {lender.phoneNumber}</Typography>
        </Box>
      )}
    />
  );
};

export default LenderInfoModal;
